import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uk-background-muted" }
const _hoisted_2 = { class: "uk-container uk-container-xlarge" }
const _hoisted_3 = {
  key: 0,
  class: "loading apollo"
}
const _hoisted_4 = {
  key: 1,
  class: "error apollo"
}
const _hoisted_5 = {
  key: 2,
  class: "result apollo uk-text-left"
}
const _hoisted_6 = { class: "uk-margin-top" }
const _hoisted_7 = { class: "uk-margin-small-top" }
const _hoisted_8 = {
  key: 0,
  class: "uk-label uk-label-warning"
}
const _hoisted_9 = {
  key: 1,
  class: "uk-label uk-label-orange"
}
const _hoisted_10 = {
  key: 2,
  class: "uk-label uk-label-success"
}
const _hoisted_11 = {
  key: 3,
  class: "uk-label uk-label-danger"
}
const _hoisted_12 = {
  key: 4,
  class: "uk-label uk-label-danger"
}
const _hoisted_13 = {
  key: 5,
  class: "uk-label"
}
const _hoisted_14 = { class: "uk-width-1-1" }
const _hoisted_15 = { class: "uk-margin-small-left uk-flex uk-grid uk-width-1-1" }
const _hoisted_16 = { class: "uk-width-1-3" }
const _hoisted_17 = { class: "uk-card-small uk-card-default uk-card-body uk-margin-top uk-margin-bottom" }
const _hoisted_18 = { class: "uk-table uk-table-striped uk-table-middle uk-table-small uk-table-divider" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "uk-margin-top" }
const _hoisted_24 = {
  key: 3,
  class: "no-result apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderDetailHeader = _resolveComponent("OrderDetailHeader")!
  const _component_TerminalAddressCard = _resolveComponent("TerminalAddressCard")!
  const _component_ReceiverAddressCard = _resolveComponent("ReceiverAddressCard")!
  const _component_BillToAddressCard = _resolveComponent("BillToAddressCard")!
  const _component_OrderContainerTable = _resolveComponent("OrderContainerTable")!
  const _component_VesselFinderEmbed = _resolveComponent("VesselFinderEmbed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("nav", {
      id: "mainNavbar",
      class: "uk-navbar-container",
      style: {"background-color":"black"},
      "uk-navbar": ""
    }, [
      _createElementVNode("a", {
        class: "uk-margin-left uk-margin-top logo uk-text-left",
        href: "https://contrak.us",
        target: "_blank",
        style: {"color":"white"}
      }, " contrak "),
      _createElementVNode("h2", {
        class: "uk-margin-left uk-margin-top uk-text-left",
        style: {"color":"white"}
      }, " | "),
      _createElementVNode("h2", {
        class: "uk-margin-left uk-margin-top uk-text-left",
        style: {"color":"white"}
      }, " Customer Portal ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Could not find that order. Whoops. "))
          : (_ctx.order)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.order.company.name) + " | Order Status", 1),
                _createVNode(_component_Button, {
                  class: "uk-margin-bottom",
                  href: _ctx.generateHashForBillingCustomer(_ctx.order.billTo.id)
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" View all orders ", -1)
                  ]))]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_OrderDetailHeader, {
                  showAvailabilityButton: false,
                  order: _ctx.order
                }, null, 8, ["order"]),
                _createElementVNode("p", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("b", null, "Order Status:", -1)),
                  (!_ctx.order.status)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Unknown"))
                    : (_ctx.order.status == 'Complete')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Complete"))
                      : (_ctx.order.status === 'In Progress')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.order.status), 1))
                        : (_ctx.order.status === 'Not Available')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Not Available"))
                          : (_ctx.order.status === 'Cancelled')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Cancelled"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.order.status), 1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_TerminalAddressCard, {
                      class: "uk-width-1-3",
                      isExportOrder: _ctx.isExportOrder,
                      order: _ctx.order
                    }, null, 8, ["isExportOrder", "order"]),
                    _createVNode(_component_ReceiverAddressCard, {
                      order: _ctx.order,
                      class: "uk-width-1-3",
                      editable: false,
                      showDetails: false,
                      showEditContact: false
                    }, null, 8, ["order"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_BillToAddressCard, {
                        billingContact: _ctx.order.billingContact,
                        orderId: _ctx.order.id,
                        billTo: _ctx.order.billTo,
                        editable: false,
                        showDetails: false,
                        showEditContact: false
                      }, null, 8, ["billingContact", "orderId", "billTo"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("th", null, "Ship Line", -1)),
                        (_ctx.isExportOrder)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Booking number"))
                          : (_ctx.order.billOfLading)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_20, "Bill Of Lading"))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createElementVNode("th", null, "Vessel Name", -1)),
                        _createElementVNode("th", null, _toDisplayString(!_ctx.isExportOrder ? 'Vessel ETA' : 'Vessel Cutoff'), 1),
                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "Carrier Reference #", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.order.shipLine), 1),
                        (_ctx.order.billOfLading)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.order.billOfLading.billOfLadingId), 1))
                          : (_ctx.isExportOrder)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(_ctx.order.bookingNumber), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("td", null, _toDisplayString(_ctx.order.vesselName), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.order.vesselEtaString), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.order.referenceNumber), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.order.billingReferenceNumber), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_OrderContainerTable, {
                  showDriver: false,
                  editable: false,
                  order: _ctx.order,
                  containersWithTrips: _ctx.containersWithTrips
                }, null, 8, ["order", "containersWithTrips"]),
                (_ctx.order.vessel)
                  ? (_openBlock(), _createBlock(_component_VesselFinderEmbed, {
                      key: 0,
                      class: "uk-margin-top",
                      mssi: _ctx.order.vessel.mssi
                    }, null, 8, ["mssi"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, "No result :("))
    ])
  ]))
}